<template>
  <v-dialog v-model="dialog" max-width="390">
    <v-card style="border-radius: 10px" color="#D9D9D9">
      <v-card-title
        class="text-h4 d-flex justify-center"
        style="background: #3c033d"
      >
        <p class="white--text mb-0">Selamat!</p>
      </v-card-title>

      <v-card-text>
        <div class="d-flex justify-center my-2">
          <img
            src="../../assets/img/vcr_icon.svg"
            height="100px"
            alt="teman bakat voucher"
          />
        </div>
        <p class="text-center primary_color">
          Kode Voucher Tes <span class="font-weight-bold">Minat Jurusan</span>
        </p>
        <p class="txt_vcr text-center" @click="copyVcr('MINATJUR22')">MINATJUR22</p>
        <p class="text-center primary_color">
          Silakan gunakan kode voucher ini pada Aplikasi Teman Bakat
        </p>
        <div class="d-flex justify-center mt-3">
          <img
            src="https://temanbakat.id/welcome/wp-content/uploads/2021/08/Googleplay-button0.png"
            @click="redirectDownload('android')"
            height="35px"
            class="mr-2"
            alt="download teman bakat"
          />
          <img
            src="https://temanbakat.id/welcome/wp-content/uploads/2021/08/Button-Download-di-App-Store.png"
            @click="redirectDownload('ios')"
            height="35px"
            alt="download teman bakat"
          />
        </div>
        <div class="py-1">
          <v-snackbar color="success" top v-model="snackbar" :timeout="5000">
            Voucher Copied!

            <template v-slot:action="{ attrs }">
              <v-btn dark v-bind="attrs" icon @click="snackbar = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
        </div>
      </v-card-text>

      <v-card-actions> </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "getVcrMinatKepribadian",
  props: ["dialog"],
  data() {
    return {
      snackbar: false,
    };
  },
  methods: {
    redirectDownload(type) {
      if (type == "android") {
        window.open(
          "https://play.google.com/store/apps/details?id=com.temanbakat&pli=1",
          "_blank",
        );
      } else {
        window.open(
          "https://apps.apple.com/id/app/teman-bakat/id1588358323",
          "_blank",
        );
      }
    },
    copyVcr(vcr) {
      navigator.clipboard.writeText(vcr).then(() => (this.snackbar = true));
    },
  },
};
</script>

<style scoped>
.primary_color {
  color: #3c033d;
}
.txt_vcr {
  font-family: Montserrat;
  font-size: 50px;
  font-weight: 800;
  line-height: 30px;
  color: #3c033d;
  cursor: pointer;
}
</style>
